"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _useQuestionSelectionActions = require("../../hooks/questionnaire/useQuestionSelectionActions");
var _r10SourceLibrary = require("r10-source-library");
var _r10CommonComponents = require("r10-common-components");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var mapChoices = function mapChoices(choices) {
  var imagePickerOptions = [];
  choices.forEach(function (choice, index) {
    var option = {
      id: "image-picker-item-".concat(index),
      title: choice.text,
      value: choice.text
    };
    (choice === null || choice === void 0 ? void 0 : choice.image) && imagePickerOptions.push(_objectSpread(_objectSpread({}, option), {}, {
      image: {
        alt: choice.text,
        src: choice.image
      }
    }));
  });
  return {
    imagePickerOptions: imagePickerOptions
  };
};
var QuestionWithImages = function QuestionWithImages(_ref) {
  var question = _ref.question,
    selections = _ref.selections;
  var maxSelections = question.maxSelections;
  var isSelected = function isSelected(choice) {
    return selections.includes(choice.text);
  };
  var _useQuestionSelection = (0, _useQuestionSelectionActions.useQuestionSelectionActions)(question),
    addSelection = _useQuestionSelection.addSelection,
    removeSelection = _useQuestionSelection.removeSelection,
    replaceSelection = _useQuestionSelection.replaceSelection;
  var onSelectionClick = function onSelectionClick(e) {
    var choice = question.choices.find(function (choice) {
      return choice.text === e.target.value;
    });
    if (isSelected(choice)) {
      removeSelection(choice.text);
      return;
    }
    if (maxSelections === 1) {
      replaceSelection(choice.text);
      return;
    }
    question.choices.filter(function (c) {
      return c.text !== choice.text && c.exclusive !== choice.exclusive && isSelected(c);
    }).forEach(function (c) {
      return removeSelection(c.text);
    });

    // if multiple selections are allowed, add the selection only if
    // limit has not been reached
    if (!maxSelections || selections.length < maxSelections) {
      addSelection(choice.text);
    }
  };
  var _mapChoices = mapChoices(question.choices),
    imagePickerOptions = _mapChoices.imagePickerOptions;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, imagePickerOptions.length !== 0 && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10CommonComponents.ImagePickerItem, {
    onChange: onSelectionClick,
    selected: selections,
    label: question.title,
    groupName: 'Default',
    items: imagePickerOptions,
    columns: {
      sm: 2,
      md: 4,
      lg: 4
    }
  }))));
};
var _default = QuestionWithImages;
exports.default = _default;